import { render, staticRenderFns } from "./WeekdaysSelector.vue?vue&type=template&id=58de97ce&scoped=true"
import script from "./WeekdaysSelector.vue?vue&type=script&lang=js"
export * from "./WeekdaysSelector.vue?vue&type=script&lang=js"
import style0 from "./WeekdaysSelector.vue?vue&type=style&index=0&id=58de97ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de97ce",
  null
  
)

export default component.exports